import { Box, Grid } from '@mui/material';
import { Footer, ResponsiveDrawer } from 'components/layout';
import { DrawerHeader } from 'components/layout/ResponsiveDrawer/styles';
import useStyles from './styles';

// Shell de la aplicacion: sticky footer.
//
// `main` es una columna flex con `minHeight: 100vh` y el area de contenido lleva
// `flexGrow: 1`. Con contenido corto, el area estira hasta llenar la pantalla y el
// footer se apoya justo abajo, SIN generar scroll. Con contenido largo, el area crece
// con su contenido, `main` supera los 100vh y la pagina scrollea normal, con el footer
// despues del contenido.
//
// Ojo: es `minHeight`, no `height`. Con `height: 100vh` el footer quedaria clavado al
// viewport y el scroll pasaria a ser interno del area de contenido, que no es lo que
// queremos: el scroll de la pagina se mantiene como en el resto de la app.
//
// Antes el area de contenido llevaba `minHeight: 90vh`. Como el chrome (toolbar +
// padding + footer) suma ~160px, la pagina medía 90vh + 160px SIEMPRE: sobraba scroll
// y el footer caia por debajo del pliegue en TODAS las vistas, aun con la pantalla
// practicamente vacia. El alto disponible ahora lo resuelve flex, no una constante.

export default function Layout({ children, className }) {
  const classes = useStyles();

  return (
    <ResponsiveDrawer classes={classes.drawer}>
      <Box
        className={classes.main}
        component="main"
        sx={{
          flexGrow: 1,
          // min-width 0 desactiva el `auto` implicito del flex item: sin esto, un hijo
          // ancho (una tabla, un bloque de codigo) impide encoger y desborda a lo ancho.
          minWidth: 0,
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <DrawerHeader />
        <Box
          sx={{
            // Crece para empujar el footer abajo cuando el contenido no llena la
            // pantalla; con contenido largo crece con el y la pagina scrollea.
            flexGrow: 1,
            minHeight: 0,
            p: 3,
            position: 'relative',
            display: 'flex',
            overflowX: 'hidden'
          }}
        >
          <Grid container className={classes.layout} sx={{ flexGrow: 1 }}>
            <Grid item lg={0.5} />
            <Grid
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 3,
                minWidth: 0,
                backgroundColor: 'transparent',
              }}
              lg={11}
              item
            >
              {children}
            </Grid>
            <Grid item lg={0.5} />
          </Grid>
        </Box>
        <Footer />
      </Box>
    </ResponsiveDrawer>
  );
}
